(() => {
  if(window.smbbsupportjsInstalled) return;
  window.smbbsupportjsInstalled = true;
  const init = root => {
    root.querySelectorAll?.('.bb-support').forEach(support => {
      if (support.dataset.bbSupportReady === 'true') return;
      support.dataset.bbSupportReady = 'true';

      const anchors = new Set();
      support.querySelectorAll('[data-sm-support-anchor]').forEach(item => {
        const anchor = item.dataset.smSupportAnchor;
        if (!anchors.has(anchor)) { item.id = anchor; anchors.add(anchor); }
      });
      const motionItems = [...support.querySelectorAll('.bb-support-motion, .bb-support-card')];
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const motionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            motionObserver.unobserve(entry.target);
            entry.target.animate([{ opacity: .7 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
          });
        }, { threshold: .08 });
        motionItems.forEach(item => motionObserver.observe(item));
        support.smMotionObserver = motionObserver;
      }

      support.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', event => {
          const target = support.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          if (target.matches('details')) { if (target.smSupportDisclosure) target.smSupportDisclosure(true); else target.open = true; }
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
          const focusTarget = target.matches('details') ? target.querySelector('summary') : target.querySelector('input:not([type="hidden"]), button, [tabindex]');
          focusTarget?.focus({ preventScroll: true });
        });
      });

      const form = support.querySelector('.bb-support-form');
      if (!form) return;
      form.noValidate = true; // Native validation remains available when JavaScript is disabled.
      const initialTarget = location.hash ? document.getElementById(location.hash.slice(1)) : null;
      if (initialTarget?.matches('details')) initialTarget.open = true;
      const fields = [...form.querySelectorAll('[required]')];
      const showError = field => {
        const output = form.querySelector(`[data-bb-error-for="${CSS.escape(field.id)}"]`);
        if (!output) return field.validity.valid;
        let message = '';
        if (field.validity.valueMissing) message = `${field.labels?.[0]?.textContent.trim() || 'This field'} is required.`;
        else if (field.validity.typeMismatch) message = 'Enter a valid email address.';
        output.textContent = message;
        field.setAttribute('aria-invalid', String(!field.validity.valid));
        return field.validity.valid;
      };
      fields.forEach(field => {
        field.addEventListener('blur', () => showError(field));
        field.addEventListener('input', () => { if (field.getAttribute('aria-invalid') === 'true') showError(field); });
        field.addEventListener('change', () => { if (field.getAttribute('aria-invalid') === 'true') showError(field); });
      });
      const validateSubmit = event => {
        const firstInvalid = fields.reduce((first, field) => {
          const valid = showError(field);
          return first || (valid ? null : field);
        }, null);
        if (!firstInvalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        firstInvalid.focus();
      };
      // Reject incomplete forms before Shopify's click-driven challenge handler.
      form.addEventListener('click', event => {
        if (event.target.closest('button[type="submit"],input[type="submit"]')) validateSubmit(event);
      }, true);
      form.addEventListener('submit', validateSubmit);
    });
  };
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.bb-support').forEach(el => el.smMotionObserver?.disconnect()));
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
